'use client';
import * as Sentry from '@sentry/browser';
import { useEffect } from 'react';

import { useUser } from '@/hooks/auth';
import { useTenant } from '@/hooks/queries/tenant';
import { env } from '@/env';

export function SentryProvider({ children }: { children: React.ReactNode }) {
  const { data: user } = useUser();
  const { data: tenant } = useTenant();

  useEffect(() => {
    if (!env.NEXT_PUBLIC_SENTRY_DSN) return;

    Sentry.init({
      dsn: env.NEXT_PUBLIC_SENTRY_DSN,
      tracesSampleRate: 0,
      release: process.env.NEXT_PUBLIC_RELEASE_VERSION,
    });
  }, []);

  useEffect(() => {
    if (!user) return;
    Sentry.setUser({
      id: user.id,
      email: user.email,
      username: user.user_metadata?.name,
    });
  }, [user]);

  useEffect(() => {
    if (!tenant) return;
    Sentry.setContext('tenant', {
      id: tenant.id,
      name: tenant.name,
      salon_name: tenant.salon_name,
      domain: tenant.domain,
    });
  }, [tenant]);

  return <>{children}</>;
}
